/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForServiceNowChangeManagement extends models.GovernanceConfigurationBaseForServiceNow {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForServiceNowChangeManagement");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForServiceNowChangeManagement.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForServiceNowChangeManagement>): GovernanceConfigurationForServiceNowChangeManagement {
        let obj = Object.assign(new GovernanceConfigurationForServiceNowChangeManagement(), model);
        GovernanceConfigurationForServiceNowChangeManagement.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForServiceNowChangeManagement>): GovernanceConfigurationForServiceNowChangeManagement {
        if (!model) return null;
        return GovernanceConfigurationForServiceNowChangeManagement.newInstance(<GovernanceConfigurationForServiceNowChangeManagement> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForServiceNowChangeManagement) {
        if (!obj) return;

        models.GovernanceConfigurationForServiceNowChangeManagement.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForServiceNowChangeManagement): boolean {
        if (models.GovernanceConfigurationBaseForServiceNow.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForServiceNowChangeManagement.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.attribute_mapping) {
            for (let val of this.attribute_mapping) {
                models.ServiceNowConfigurationComponent.fixupPrototype(val);
            }
        }
        if (this.risk_assessments) {
            for (let val of this.risk_assessments) {
                models.ServiceNowConfigurationComponent.fixupPrototype(val);
            }
        }
    }

    attribute_mapping: Array<models.ServiceNowConfigurationComponent>;

    risk_assessments: Array<models.ServiceNowConfigurationComponent>;

}
